import './avatar-picker.css';
import './wordpacks.css';
import './players.css';
import './word-cards.css';
import './game-screen.css';
import { GAME_RULES, applyGuessBonus, evaluateVotes } from './game-rules';
import { scoreLocalGuess, scoreLocalRound } from './local-reducer';
import { RealtimeClient } from './realtime-client';
import { initFog } from './fog-background';
import { initDragFlip } from './drag-flip-card';
import './swirl-canvas';
import './confetti';
import './i18n';
import type { CommandType, LobbySnapshot } from './types';

initFog(document.getElementById('particle-canvas') as HTMLCanvasElement | null);
initDragFlip();

const isApp = location.protocol === 'file:' || Boolean((window as { Capacitor?: unknown }).Capacitor);
const apiBase = isApp ? 'https://deducto.de/api' : '/api';
const client = new RealtimeClient(apiBase);
const ready = client.initialize();

const bridge = {
  ready,
  available: () => client.isEnabled(),
  hasSession: () => client.hasSession(),
  activeFor: (code?: string) => client.isActive(code),
  create: (payload: Record<string, unknown>) => client.create(payload),
  join: (code: string, payload: Record<string, unknown>) => client.join(code, payload),
  listLobbies: (offset = 0, limit = 50) => client.listLobbies(offset, limit),
  resume: () => client.resume(),
  command: (type: CommandType, payload: Record<string, unknown> = {}) => client.command(type, payload),
  fetchChat: (sinceId: number) => client.fetchChat(sinceId),
  subscribe: (listener: (snapshot: LobbySnapshot) => void) => client.subscribeSnapshot(listener),
  subscribeConnection: (listener: (state: string) => void) => client.subscribeConnection(listener),
  snapshot: () => client.store.get().snapshot,
  clear: () => client.clear(),
};

declare global {
  interface Window {
    DeductoV2: typeof bridge;
    DeductoRules: {
      rules: typeof GAME_RULES;
      evaluateVotes: typeof evaluateVotes;
      applyGuessBonus: typeof applyGuessBonus;
      scoreLocalRound: typeof scoreLocalRound;
      scoreLocalGuess: typeof scoreLocalGuess;
    };
  }
}

window.DeductoV2 = bridge;
window.DeductoRules = {
  rules: GAME_RULES,
  evaluateVotes,
  applyGuessBonus,
  scoreLocalRound,
  scoreLocalGuess,
};

client.subscribeConnection((state) => {
  document.documentElement.dataset.connection = state;
  const lobbyCode = document.getElementById('lobby-code');
  if (lobbyCode?.parentElement) {
    let indicator = document.getElementById('realtime-state');
    if (!indicator) {
      indicator = document.createElement('span');
      indicator.id = 'realtime-state';
      indicator.style.cssText = 'margin-left:8px;font-size:10px;vertical-align:middle;';
      lobbyCode.parentElement.appendChild(indicator);
    }
    const labels: Record<string, string> = {
      connected: '● LIVE',
      connecting: '● REJOIN',
      degraded: '● SYNC',
      offline: '● OFFLINE',
      disabled: '',
    };
    indicator.textContent = labels[state] ?? '';
    indicator.style.color = state === 'connected' ? '#22c55e' : state === 'offline' ? '#ef4444' : '#f59e0b';
  }
});
